<template>
  <div>
    <BackNav :title="$t('setting.title')" isLink @onGoBanckHandler="goBanckHandler" />
    <ul class="group">
      <li class="item" @click="uploaderAvatarHandler">
        <div class="avatar-group">
          <img src="./../../assets/images/default_avatar.jpeg" class="avatar" />
          {{ $t('setting.changeAvatar') }}
        </div>
        <van-icon name="arrow" class="item-icon" />
      </li>
      <li class="item" @click="changePasswordHandler">{{ $t('setting.changePassword') }}<van-icon name="arrow" class="item-icon" /></li>
      <li class="item" @click="printHandler">{{ $t('setting.changePrint') }}<van-icon name="arrow" class="item-icon" /></li>
    </ul>
  </div>
</template>

<script setup>
import BackNav from '@/components/BackNav';
import { useRouter } from 'vue-router';
const router = useRouter();
const goBanckHandler = () => {
  router.push('/my');
};
const uploaderAvatarHandler = () => {
  router.push('/avatar');
};
const changePasswordHandler = () => {
  router.push('/changePassword');
};
const printHandler = () => {
  router.push('/printTemplate');
};
</script>

<style lang="scss" scoped>
.group {
  padding: 20px;
  box-sizing: border-box;
  .item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    line-height: 100px;
    border-bottom: 1px solid #f5f6f7;
    color: #555;
    .item-icon {
      font-size: 50px;
      color: #555;
    }
    .avatar-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 20px;
      }
    }
  }
}
</style>
